import React, { FC, useContext, useState } from 'react';

import { Table } from '@smartshell/ui-kit';
import { useNavigate } from 'react-router';

import { AuthContext } from 'auth';
import { NotPermissionModal } from 'modals';

import { IWorkersTableProps } from '../../types';
import { useGetColumns } from './UseGetColumns';

const WorkersTable: FC<IWorkersTableProps> = ({ workers }) => {
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const [notPermissionModalOpen, setNotPermissionModalOpen] =
    useState<boolean>(false);

  const columns = useGetColumns();

  return (
    <>
      {notPermissionModalOpen && (
        <NotPermissionModal onClose={() => setNotPermissionModalOpen(false)} />
      )}
      <Table
        data={workers}
        columns={columns}
        onRowDoubleClick={(_, worker) => {
          if (!permissions?.has('client_info'))
            return setNotPermissionModalOpen(true);

          navigate(`/workers/${worker.uuid}`);
        }}
      />
    </>
  );
};

export default WorkersTable;
